import { render, staticRenderFns } from "./moreWrapperModal.vue?vue&type=template&id=34df554a&scoped=true&"
import script from "./moreWrapperModal.vue?vue&type=script&lang=ts&"
export * from "./moreWrapperModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34df554a",
  null
  
)

export default component.exports